<template>
  <div>
    <!-- Now a three part databox (2 and 3 must be fields on the detail, and 1 on the main project)-->
    <wc-data-box
      :title='title'
      :showEdit='!project.archived'
      @edit='editProject'
      :showHelp='showHelp'
      :helpText='helpText'
    >
      <div v-if='firstPart'>
        <v-subheader>{{ firstLabel }}</v-subheader>
        <p v-if='project[firstPart] !== null && project[firstPart].length' class='px-4'>
          {{ project[firstPart] }}
        </p>
        <p v-else class='px-4 grey--text text--lighten-1 font-italic caption'>(not specified)</p>
      </div>

      <v-subheader>{{ secondLabel }}</v-subheader>
      <p v-if='project.project_detail[secondPart] !== null && project.project_detail[secondPart].length' class='px-4'>
        {{ project.project_detail[secondPart] }}
      </p>
      <p v-else class='px-4 grey--text text--lighten-1 font-italic caption'>(not specified)</p>
      <v-subheader>{{ thirdLabel }}</v-subheader>
      <p v-if='project.project_detail[thirdPart] !== null && project.project_detail[thirdPart].length' class='px-4'>
        {{ project.project_detail[thirdPart] }}
      </p>
      <p v-else class='px-4 grey--text text--lighten-1 font-italic caption'>(not specified)</p>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :loadingButtons='savingProject'
      title='Edit'
      @cancel='showDialog = false'
      @save='saveProject'
      width='600'
    >
      <v-form>
        <v-subheader v-if='firstPart'>{{ firstLabel }}{{ firstPart === "customer_notes" ? " (under construction) " : "" }}</v-subheader>
        <v-textarea v-if='firstPart' outlined auto-grow v-model='projectCopy[firstPart]'></v-textarea>
        <v-subheader>{{ secondLabel }}</v-subheader>
        <v-textarea outlined auto-grow v-model='projectCopy.project_detail[secondPart]'></v-textarea>
        <v-subheader>{{ thirdLabel }}</v-subheader>
        <v-textarea outlined auto-grow v-model='projectCopy.project_detail[thirdPart]'></v-textarea>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'irrigation-three-part-data-box',
  props: {
    project: {
      required: true
    },
    title: {
      required: true,
      type: String
    },
    firstLabel: {
      required: false,
      type: String,
      default: ''
    },
    secondLabel: {
      required: true,
      type: String
    },
    thirdLabel: {
      required: true,
      type: String
    },
    firstPart: {
      required: false,
      default: '',
      type: String
    },
    secondPart: {
      default: 'su_instr_perm_office',
      type: String
    },
    thirdPart: {
      default: 'bd_instr_perm_office',
      type: String
    },
    showHelp: {
      required: false,
      type: Boolean,
      default: false
    },
    helpText: {
      required: false,
      type: String,
      default: ""
    }
  },
  data: () => ({
    showDialog: false,
    savingProject: false,
    projectCopy: { project_detail: {} },
  }),
  methods: {
    async editProject () {
      this.showDialog = true
      this.projectCopy = _.cloneDeep(this.project)
    },
    saveProject () {
      this.savingProject = true
      this.$emit('update', this.projectCopy)
      this.savingProject = false
      this.showDialog = false
    }
  }
}
</script>
